var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWordpress = function SvgWordpress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a90578b2-190a-4c8a-9bef-2ae095694224",
    "data-name": "af694e49-40ca-4941-9674-a21d73aeb644",
    viewBox: "0 0 122.6 122.6",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "edea76ef-9e82-4837-90a8-bda848f40f3e",
    "data-name": "b7421ea8-d3e5-4cf7-bae3-e04afce45603"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.7,61.3a52.6,52.6,0,0,0,29.6,47.3l-25-68.7A50.9,50.9,0,0,0,8.7,61.3Z",
    transform: "translate(0.1 0)",
    style: {
      fill: "#183149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7,58.6a27.6,27.6,0,0,0-4.3-14.5c-2.7-4.3-5.2-8-5.2-12.3a9.1,9.1,0,0,1,8.9-9.3h.7a52.5,52.5,0,0,0-74.2,3.2,57,57,0,0,0-5.2,6.7h3.3c5.5,0,14-.7,14-.7a2.2,2.2,0,0,1,.4,4.3s-2.9.4-6,.5l19.1,57L59.7,59.1,51.5,36.6c-2.8-.1-5.5-.5-5.5-.5-2.8-.1-2.5-4.5.3-4.3,0,0,8.7.7,13.9.7s14-.7,14-.7a2.2,2.2,0,0,1,1.9,2.5,2.3,2.3,0,0,1-1.6,1.8s-2.8.4-6,.5l19,56.5,5.2-17.5C95,68.3,96.7,63.1,96.7,58.6Z",
    transform: "translate(0.1 0)",
    style: {
      fill: "#183149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2,65.9,46.4,111.7a53.6,53.6,0,0,0,14.9,2.1,51.8,51.8,0,0,0,17.4-3,2.5,2.5,0,0,1-.4-.7Z",
    transform: "translate(0.1 0)",
    style: {
      fill: "#183149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.4,36a48.9,48.9,0,0,1,.3,5.4,49.3,49.3,0,0,1-4,18.9l-16,46.4A52.7,52.7,0,0,0,107.4,36Z",
    transform: "translate(0.1 0)",
    style: {
      fill: "#183149"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3,0a61.3,61.3,0,1,0,61.2,61.4h0A61.4,61.4,0,0,0,61.3,0Zm0,119.7a58.5,58.5,0,1,1,58.4-58.6v.2A58.6,58.6,0,0,1,61.3,119.7Z",
    transform: "translate(0.1 0)",
    style: {
      fill: "#183149"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWordpress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wordpress.e96c2b80.svg";
export { ForwardRef as ReactComponent };